require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
const $ = window.$ = window.jQuery = require("jquery");

window.I18n = require("i18n-js");

import "datatables.net-bs4/css/dataTables.bootstrap4.css"
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css"
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.css"
import "datatables.net-select-bs4/css/select.bootstrap4.css"

import "dropzone/dist/dropzone.css"
window.Dropzone = require("dropzone/dist/dropzone");

import "popper.js"
require("jquery-toast-plugin")
import "jquery-toast-plugin/dist/jquery.toast.min.css"
require("../backoffice/utils/theme/pages/toastr.init")
require('nestable2')
require('nestable2/jquery.nestable.css')
import "bootstrap-select/dist/css/bootstrap-select.css"
import "bootstrap"
import "../backoffice/assets/styles/backoffice.scss"
import Application from "../backoffice/Application";

import "common/utils/plugins/dropify/dist/js/dropify"
import "common/utils/plugins/dropify/dist/css/dropify.min.css"
import 'jquery-validation'

import "../backoffice/utils/NativeConfirm.js"
import "../common/utils/uppercase_fields.js"

require("bootstrap-select");
require("datatables.net/js/jquery.dataTables")
require("datatables.net-bs4/js/dataTables.bootstrap4.min")
require("datatables.net-responsive/js/dataTables.responsive")
require("datatables.net-responsive-bs4/js/responsive.bootstrap4.min")
require("datatables.net-buttons/js/dataTables.buttons")
require("datatables.net-buttons-bs4/js/buttons.bootstrap4.min")
require("datatables.net-buttons/js/buttons.html5")
require("datatables.net-buttons/js/buttons.flash")
require("datatables.net-buttons/js/buttons.print")
require("datatables.net-keytable/js/dataTables.keyTable")
require("datatables.net-select/js/dataTables.select")
require("pdfmake/build/pdfmake")
require("pdfmake/build/vfs_fonts")

require("trix")
require("@rails/actiontext")

const select2 = require('select2');
global.select2 = select2;

window.application = new Application();

require("../backoffice/utils/theme/vendor");
$(document).on('turbolinks:load', function(event) {

    $(document).on("submit", "form[method=get]", function(e) {
        Turbolinks.visit(this.action+(this.action.indexOf('?') === -1 ? '?' : '&')+$(this).serialize());
        return false;
    });

    Turbolinks.setProgressBarDelay(500);

    let $body = $("body");
    application.setController($body.data("controller"));
    application.setAction($body.data("action"));
    application.pageChanged();

    require("../backoffice/utils/theme/app");
    $.App.init();
    Waves.init();
});